export default function FlatLock() {
  return (
    <svg width='17.143' height='20' viewBox='0 0 17.143 20'>
      <path
        id='f200'
        d='M.982,20a.945.945,0,0,1-.692-.29A.945.945,0,0,1,0,19.018V9.554a.945.945,0,0,1,.29-.692.945.945,0,0,1,.692-.29h.982V7.188a7.227,7.227,0,0,1,1.92-5.134A6.173,6.173,0,0,1,8.571,0a6.173,6.173,0,0,1,4.688,2.054,7.227,7.227,0,0,1,1.92,5.134V8.571h.982a.991.991,0,0,1,.982.982v9.464a.991.991,0,0,1-.982.982ZM4.33,7.188V8.571h8.482V7.188a5.024,5.024,0,0,0-1.25-3.571V3.571A3.921,3.921,0,0,0,8.571,2.277,3.921,3.921,0,0,0,5.58,3.571v.045A5.024,5.024,0,0,0,4.33,7.188ZM17.143,18.571'
        fill='#a5a8b9'
      />
    </svg>
  )
}
